<template lang="pug">
div
  .top-line.mb-L
    h1.h1 Custom fields
    BriqButton(@click="newCustomField" data-test-id="add-custom-field") Add custom field
  table(v-if="hasCustomFields").table.table--form
    thead
      tr
        th Name
        th Code
        th Description
        th Type
        th Optional
        th.actions
    CustomFieldRow(v-for="customField in customFields" :key="customField.key" :custom-field="customField")
  span(v-else) There are currently no custom fields
</template>

<script>
import CustomFieldRow from '@/vue/settings/application/custom-fields/CustomFieldRow.vue'

export default {
  components: { CustomFieldRow },
  props: {
    customFields: {
      type: Array,
      required: true,
    },
  },
  computed: {
    hasCustomFields() {
      return this.customFields && this.customFields.length > 0
    },
  },
  methods: {
    newCustomField() {
      this.$router.push({ name: 'CustomFieldNew' })
    },
  },
}
</script>

<style scoped lang="stylus">
table
  width 100%

tr
  background white

th
  padding 10px 20px

th.actions
  width 125px
</style>
